/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  OtpBackupCodes,
  SetupOtpInput,
  StandardError,
  StandardMessage,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Disable OTP Setup
 */
export const disableOtpSetup = (
    setupOtpInput: MaybeRefOrGetter<SetupOtpInput>,
 signal?: AbortSignal
) => {
      setupOtpInput = toValue(setupOtpInput);

      return axiosClient<StandardMessage>(
      {url: `/otp/disable`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setupOtpInput, signal
    },
      );
    }




export const getDisableOtpSetupMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableOtpSetup>>, TError,{data: SetupOtpInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableOtpSetup>>, TError,{data: SetupOtpInput}, TContext> => {

const mutationKey = ['disableOtpSetup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableOtpSetup>>, {data: SetupOtpInput}> = (props) => {
          const {data} = props ?? {};

          return  disableOtpSetup(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableOtpSetupMutationResult = NonNullable<Awaited<ReturnType<typeof disableOtpSetup>>>
    export type DisableOtpSetupMutationBody = SetupOtpInput
    export type DisableOtpSetupMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Disable OTP Setup
 */
export const useDisableOtpSetup = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableOtpSetup>>, TError,{data: SetupOtpInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof disableOtpSetup>>,
        TError,
        {data: SetupOtpInput},
        TContext
      > => {
      return useMutation(getDisableOtpSetupMutationOptions(options), queryClient);
    }
    /**
 * @summary Enable OTP Setup
 */
export const enableOtpSetup = (
    setupOtpInput: MaybeRefOrGetter<SetupOtpInput>,
 signal?: AbortSignal
) => {
      setupOtpInput = toValue(setupOtpInput);

      return axiosClient<OtpBackupCodes>(
      {url: `/otp/enable`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setupOtpInput, signal
    },
      );
    }




export const getEnableOtpSetupMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableOtpSetup>>, TError,{data: SetupOtpInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableOtpSetup>>, TError,{data: SetupOtpInput}, TContext> => {

const mutationKey = ['enableOtpSetup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableOtpSetup>>, {data: SetupOtpInput}> = (props) => {
          const {data} = props ?? {};

          return  enableOtpSetup(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableOtpSetupMutationResult = NonNullable<Awaited<ReturnType<typeof enableOtpSetup>>>
    export type EnableOtpSetupMutationBody = SetupOtpInput
    export type EnableOtpSetupMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Enable OTP Setup
 */
export const useEnableOtpSetup = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableOtpSetup>>, TError,{data: SetupOtpInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enableOtpSetup>>,
        TError,
        {data: SetupOtpInput},
        TContext
      > => {
      return useMutation(getEnableOtpSetupMutationOptions(options), queryClient);
    }
    /**
 * @summary Generate OTP Backup Codes
 */
export const generateOtpBackupCodes = (

 signal?: AbortSignal
) => {


      return axiosClient<OtpBackupCodes>(
      {url: `/otp/generate-backup-codes`, method: 'POST', signal
    },
      );
    }




export const getGenerateOtpBackupCodesMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateOtpBackupCodes>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateOtpBackupCodes>>, TError,void, TContext> => {

const mutationKey = ['generateOtpBackupCodes'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateOtpBackupCodes>>, void> = () => {


          return  generateOtpBackupCodes()
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateOtpBackupCodesMutationResult = NonNullable<Awaited<ReturnType<typeof generateOtpBackupCodes>>>

    export type GenerateOtpBackupCodesMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Generate OTP Backup Codes
 */
export const useGenerateOtpBackupCodes = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateOtpBackupCodes>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof generateOtpBackupCodes>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGenerateOtpBackupCodesMutationOptions(options), queryClient);
    }
    /**
 * @summary Start OTP Setup
 */
export const startOtpSetup = (

 signal?: AbortSignal
) => {


      return axiosClient<StandardMessage>(
      {url: `/otp/start`, method: 'POST', signal
    },
      );
    }




export const getStartOtpSetupMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startOtpSetup>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof startOtpSetup>>, TError,void, TContext> => {

const mutationKey = ['startOtpSetup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startOtpSetup>>, void> = () => {


          return  startOtpSetup()
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartOtpSetupMutationResult = NonNullable<Awaited<ReturnType<typeof startOtpSetup>>>

    export type StartOtpSetupMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Start OTP Setup
 */
export const useStartOtpSetup = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startOtpSetup>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof startOtpSetup>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getStartOtpSetupMutationOptions(options), queryClient);
    }
